export const appStoreSources = {
  android: 'https://play.google.com/store/apps/details?id=com.scrubstr.app&hl=en_US&gl=US',
  ios: 'https://apps.apple.com/us/app/scrubstr/id1587105280',
}
